// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OoucV","top":"styles_top__39wCa","left":"styles_left__1ie2h","description":"styles_description__3PxZi"};